import { computed } from 'vue-demi';
import { T as TimeFormat } from './TimeFormat-a7f5565b.js';

const useDateMask = (format, locale) => {
  return computed(() => {
    if (typeof format.value !== 'function') {
      const formatter = new Intl.DateTimeFormat(locale.value, {
        dateStyle: format.value,
        timeZone: 'UTC'
      });
      return formatter.formatToParts(Date.UTC(1, 0, 1, 1, 1)).reduce((mask, part) => {
        switch (part.type) {
          case 'year':
            return mask + part.value.replace(/^\d{2}$/, 'YY').replace(/^\d{4}$/, 'YYYY');
          case 'month':
            switch (format.value) {
              case 'short':
                return mask + part.value.replace(/^\d{1}$/, 'M').replace(/^\d{2}$/, 'MM');
              case 'medium':
                return mask + 'MMM';
              case 'long':
                return mask + 'MMMM';
              default:
                throw new Error('[useDateMask]: `format` has an invalid value.');
            }
          case 'day':
            return mask + part.value.replace(/^\d{1}$/, 'D').replace(/^\d{2}$/, 'DD');
          default:
            return mask + part.value;
        }
      }, '');
    }
    return format.value(undefined, locale.value);
  });
};

const useTimeMask = (format, locale) => {
  return computed(() => {
    if (typeof format.value !== 'function') {
      const formatter = new Intl.DateTimeFormat(locale.value, {
        timeStyle: 'short',
        hourCycle: format.value !== TimeFormat.Auto ? format.value : undefined,
        timeZone: 'UTC'
      });
      return formatter.formatToParts(Date.UTC(1, 0, 1, 1, 1)).reduce((mask, part) => {
        switch (part.type) {
          case 'hour':
            return mask + part.value.replace(/^\d{1}$/, 'H').replace(/^\d{2}$/, 'HH');
          case 'minute':
            return mask + part.value.replace(/^\d{1}$/, 'M').replace(/^\d{2}$/, 'MM');
          case 'dayPeriod':
            return mask + 'A';
          default:
            return mask + part.value;
        }
      }, '');
    }
    return format.value(undefined, locale.value);
  });
};

export { useTimeMask as a, useDateMask as u };
